<template>
  <div class="pa-2">
    <!-- getEntryDefault: {{ getEntryDefault }} -->
    <div v-if="selectedEntry && Object.keys(selectedEntry).length">
       <v-row>
        <v-col cols="2">
          <!-- <GoBack 
            btnSize="sm"
          /> -->
        </v-col>
        <v-col cols="8">
          <h1>{{ selectedEntry.fields.title }}</h1>
        </v-col>
        <v-col cols="2"></v-col>
      </v-row>
      <div class="subtitle-1" v-if="selectedEntry.fields.platform">Platform: {{ selectedEntry.fields.platform }}</div>
      <div class="py-2" v-html="renderHtml(selectedEntry.fields.description, renderOptions)"></div>
    </div>
  </div>
</template>

<script>
  import {createClient} from '../plugins/contentful.js'
  import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
  import { BLOCKS } from '@contentful/rich-text-types';
  import { mapGetters } from 'vuex'

  const client = createClient()

  export default {
    created() {
      console.log('[DocsPageFull] - created - entryId: ', this.entryId);
      this.getEntryFromApi(this.entryId)
      console.log('[DocsPageFull] - created - selectedEntry: ', this.selectedEntry);
    },
    
    data: () => ({
      // selectedEntry: {},
      // entryId: '15mPq0Abqq88F0Fr7K6yVN'
    }),
    computed: {
      renderOptions() {
        const options = {
          renderNode: {
            [BLOCKS.EMBEDDED_ASSET]: (node) => `<img src="${node.data.target.fields.file.url}" alt="${node.data.target.fields.title}" width="${node.data.target.fields.file.details.image.width}"/>`
          }
        }
        return options
      },
      getEntryDefault() {
        return getEntries.find((a) => a.fields.menuOrder === 0);
      }
    },
    computed: {
      ...mapGetters({
        getEntryDefault: 'contentful/getEntryDefault', 
        // getEntries: 'contentful/getEntries', 
      }),
      selectedEntry() {
        return this.getEntryDefault
      }
    },
    methods: {
      getEntryFromApi(entryId) {
        // fetch entry from contentful based on entryId
        client.getEntry(entryId)
        .then((entry) => {
          console.log('[DocsPageFull] - getEntryFromApi - entry: ', entry)
          this.selectedEntry = { ...entry }
        })
        .catch(console.error)
      },
      renderHtml(field, options) {
        return documentToHtmlString(field, options)
      }
    },
  }
</script>

<style lang="scss" scoped>
  ::v-deep p,
  ::v-deep h2,
  ::v-deep h3,
  ::v-deep h4 {
    text-align: left !important;
  }
</style>